<template>
  <div>
    <div :class="styles.circle(updated, newItem)" />
  </div>
</template>

<script>
import updateIndicatorStyles from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/updateIndicatorStyles'
export default {
  name: 'UpdateIndicator',
  props: {
    point: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    updated() {
      return this.point.updated
    },
    newItem() {
      return this.point.newItem
    },
    styles() {
      return updateIndicatorStyles
    },
  },
}
</script>

<style scoped></style>
